import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { RichText } from 'prismic-reactjs'
import { makeContentRenderable } from '../helper'
import styles from './content.module.scss'
import Button from '../Button'
import Icon from '../Icon'
import * as loaderActions from '../../actions/loader'

class ContentContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      contentToggled: false,
    }
    this.toggleContent = this.toggleContent.bind(this)
  }

  toggleContent() {
    this.setState(prevState => ({
      contentToggled: !prevState.contentToggled,
    }))
  }

  render() {
    let renderableContent = makeContentRenderable(this.props.content)
    const contentCssClass = [styles.content]
    if (this.state.contentToggled) {
      contentCssClass.push(styles.showContent)
    }
    return (
      <section key={`content`} className={contentCssClass.join(' ')}>
        {this.props.children}
        <article className={styles.inner}>
          <div>
            {this.props.title && <h1>{this.props.title[0].text}</h1>}
            {RichText.render(renderableContent).props.children}
          </div>
        </article>
        {this.props.pdf &&
          this.props.pdf.url !== null && (
            <a
              className={styles.download}
              href={this.props.pdf.url}
              target="_blank"
              title="Download tema som PDF"
            >
              <Icon icon="print" />
            </a>
          )}
      </section>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.loading && prevProps.loading !== this.props.loading) {
      setTimeout(() => this.toggleContent(), 1000)
    }
  }
}

const mapStateToProps = state => {
  return {
    loading: state.loader.loading,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

const Content = connect(mapStateToProps, mapDispatchToProps)(ContentContainer)

Content.defaultProps = {}

Content.propTypes = {}

export default Content

export const contentFragment = graphql`
  fragment Content on ArticleJson {
    data {
      content {
        type
        text
        url
        spans {
          start
          end
          type
          data {
            link_type
            name
            kind
            url
          }
        }
        oembed {
          type
          embed_url
          title
          provider_name
          thumbnail_url
          height
          width
          version
          author_name
          author_url
          provider_url
          thumbnail_width
          thumbnail_height
          html
        }
      }
    }
  }
`

/*
data {
  content {
    type
    text
    url
    spans {
      start
      end
      type
      data {
        link_type
        url
        target
      }
    }
    oembed {
      type
      embed_url
      title
      provider_name
      thumbnail_url
      height
      width
      version
      author_name
      author_url
      provider_url
      thumbnail_width
      thumbnail_height
      html
    }
  }
}
*/



// WEBPACK FOOTER //
// ./src/components/Content/index.jsx